<template>
  <div>
    <p>用户注册折线图</p>
    <div id="Broken" :style="{ width: '100%', height: '300px' }" />
  </div>
</template>
<script>
import Vue from "vue";
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
export default {
  name: "Hello",
  props: ["message2"],
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  watch: {
    message2: function(newVal, oldVal) {
      let arr = [];
      let driver = [];
      let shipment = [];
      newVal.map(function(value, index) {
        arr.push(value.dateTime);
        driver.push(value.driver);
        shipment.push(value.shipment);
      });
      this.drawLine(arr, driver, shipment);
    }
  },
  mounted() {
    //this.drawLine()
  },
  methods: {
    drawLine(r, d, s) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById("Broken"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["司机", "托运人"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: r
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "司机",
            type: "line",
            stack: "总量",
            data: d
          },
          {
            name: "托运人",
            type: "line",
            stack: "总量",
            data: s
          }
        ]
      });
    }
  }
};
</script>
